import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaFacebookSquare, FaYoutube, FaInstagramSquare, FaTwitterSquare } from "react-icons/fa";

export const FooterContainer = styled.div`
  background-color: #1b1b1b;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const FooterWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 0;
  width: 100%;
`;

export const FooterReserved = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const FooterLegal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const FooterSocialMedia = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  height: 3rem;
`;

export const Icon = styled.div`
  background-color: transparent;
  font-size: 2.5rem;
  cursor: pointer;
  outline: none;

  color: #7689de;
  &:hover {
    transition: all 0.2s ease-in-out;
    color: #96a9fe;
    font-size: 2.51rem;
  }
`;

export const FbIcon = styled(FaFacebookSquare)``;
export const YtIcon = styled(FaYoutube)``;
export const IgIcon = styled(FaInstagramSquare)``;
export const TwIcon = styled(FaTwitterSquare)``;

export const FooterP = styled.p`
  color: #fefefa;
`;

export const FooterLink = styled(Link)`
  color: #7689de;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  &:hover {
    transition: all 0.2s ease-in-out;
    color: #96a9fe;
  }
`;
